/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateJobModal_workflow$ref: FragmentReference;
declare export opaque type AddUpdateJobModal_workflow$fragmentType: AddUpdateJobModal_workflow$ref;
export type AddUpdateJobModal_workflow = {|
  +id: string,
  +name: string,
  +states: $ReadOnlyArray<{|
    +id: string,
    +isGangRun: ?boolean,
  |}>,
  +$refType: AddUpdateJobModal_workflow$ref,
|};
export type AddUpdateJobModal_workflow$data = AddUpdateJobModal_workflow;
export type AddUpdateJobModal_workflow$key = {
  +$data?: AddUpdateJobModal_workflow$data,
  +$fragmentRefs: AddUpdateJobModal_workflow$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateJobModal_workflow",
  "type": "Workflow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "states",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkflowState",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isGangRun",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a920529d7c1c08e87396862b78d1d36';
module.exports = node;
